import { cn } from "@/utils/utils";
import { Body } from "@hypercard/web-components";
import { CreateStipendStep } from "./types";

const EditSteps = [
  {
    label: "Name",
    step: CreateStipendStep.BaseForm,
  },
  {
    label: "Time & Budget",
    step: CreateStipendStep.DetailsForm,
  },
  {
    label: "Create & Test Rules",
    step: CreateStipendStep.RulePolicy,
  },
  {
    label: "Confirm",
    step: CreateStipendStep.Confirmation,
  },
];

export const StepperLegend = ({ step }: { step: CreateStipendStep }) => {
  const currentStepIndex = EditSteps.findIndex(
    (editStep) => editStep.step === step,
  );
  return (
    <div className="space-y-6">
      {EditSteps.map((step, stepIndex) => {
        const isCompleted = stepIndex < currentStepIndex;
        const isActive = stepIndex === currentStepIndex;
        return (
          <div
            key={step.step}
            className="flex max-w-24 items-center gap-x-1 overflow-hidden md:max-w-none md:gap-x-3"
          >
            <div
              className={cn(
                "m-2 flex size-4 shrink-0 items-center justify-center rounded-full border-2 border-slate",
                { "border-white": isCompleted || isActive },
              )}
            >
              <div
                className={cn("size-2 rounded-full", {
                  "bg-white": isCompleted,
                })}
              />
            </div>
            <Body
              size="md"
              weight="medium"
              className={cn("text-slate", {
                "text-white": isCompleted || isActive,
              })}
            >
              {step.label}
            </Body>
          </div>
        );
      })}
    </div>
  );
};
